import Back from '@/components/public/back/Back.vue';
import {mapState} from 'vuex';
import api from '../../../../common/libs/api.js';
import {upper} from '../../../../common/libs/common.js';
import utils from '@/common/libs/utils'

export default{
  name: 'ChangeCity',
  components: {
    Back
  },
  data(){
    return {
      openCityId: '',
      allCityId: '',
      upper: upper
    }
  },
  computed: mapState({
    city: state => state.home.city,
    location: state => state.home.location,
    openCitys: state => state.home.citys.openCitys
    // allCitys: state => state.home.citys.allCitys
  }),
  asyncData({store, route}){
    let obj = {};
    return store.dispatch('initCitiesData', obj);
  },
  methods: {
    openCityLink(city){
      if (!this.$route.query.name) {
        return '/bj'
      }
      let temp = this.$route.query.name.replace('/qt/noline', '/qt')
      var reg = /^[a-zA-Z0-9/]+$/g;
      //非法链接跳转到默认北京
      if (!reg.test(temp)){
        return '/bj'
      }
      let arr = temp.split('/')
      if (arr[2] == 'course' || arr[2] == '') {
        arr[1] = city.first_word == 'qt' ? 'qt/noline' : city.first_word;
      } else {
        arr[1] = city.first_word
      }
      
      return arr.join('/');
    },
    // otherCityLink(city){
    //   return `/bj/noline?city=${  city.first_word}`;
    // },
    go(){
      //和openCityLink和otherCityLink一样的逻辑，直接用就可以
      let link = null;

      if (this.location.open_city){
        link = this.openCityLink(this.location);
      } else {
        // link = this.otherCityLink(this.location);
      }
      this.$store.commit('setCity', this.location);

      this.$router.push({path: link});
    },
    refreshLocation(){
      //重新获取定位城市
      this.$store.commit('changeIsGet', 3);
      if (navigator.geolocation){
        navigator.geolocation.getCurrentPosition(this.getPosition, this.getPosition);
      } else {
        this.$store.dispatch('toast', {title: '当前浏览器未提供定位服务，请使用其他浏览器打开', show: true});
        this.getPosition({})
      }

    },
    getPosition(position){
      let vm = this;
      let lat = '', lng = '';

      if (position.coords){
        lat = position.coords.latitude;
        lng = position.coords.longitude;
      }
      let obj = {
        lat,
        lng
      };
      vm.$store.dispatch('getCity', obj);
    }
    // goAlpha(alpha){

    //   document.getElementById(alpha).scrollIntoView({behavior: 'smooth', block: 'start'});
    // }
  },
  mounted(){
    this.$store.commit('isShowLoading', false);

    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
  }
}


// WEBPACK FOOTER //
// ./src/components/homePage/home/changeCity/changeCity.js